import type { TextProps } from '@features/powerpoint';
import { themeV2 } from '../domain/theme-v2';
import { DEFAULT_FONT } from './constants-v2';

export const textStylesV2: Record<string, TextProps['options']> = {
  contentSlideDefaults: {
    color: themeV2.colors.metricBlue,
    fontFace: DEFAULT_FONT,
  },
  titleSlideDefaults: {
    color: themeV2.colors.white,
    fontFace: DEFAULT_FONT,
  },
};

export const headerTextStylesV2 = {
  contentSlide: {
    color: themeV2.colors.metricBlue,
    fontSize: themeV2.fontSizes.h1,
    bold: true,
    fontFace: DEFAULT_FONT,
    h: 0.75,
    w: 12.67,
    x: 0.33,
    y: 0.25,
  },
  titleSlide: {
    color: themeV2.colors.white,
    fontSize: 28,
    bold: true,
    fontFace: DEFAULT_FONT,
    h: 1.04,
    w: 11.82,
    x: 0.74,
    y: 0.78,
  },
} as const satisfies Record<string, TextProps['options']>;
